import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "sonner";
import { ArrowLeft, KeyRound } from "lucide-react";
import { API, formatApiErrorDetail } from "@/context/AuthContext";

const EASE = [0.16, 1, 0.3, 1];

export default function ResetPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Les deux mots de passe ne correspondent pas");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      setDone(true);
      toast.success("Mot de passe mis à jour !");
      setTimeout(() => navigate("/connexion"), 2000);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="info-page" data-testid="reset-page">
      <header className="info-header">
        <Link to="/connexion" className="info-back" data-testid="back-login-link">
          <ArrowLeft size={16} />
          Retour à la connexion
        </Link>
        <Link to="/" className="logo logo-link" data-testid="brand-home-link" aria-label="SamNara — accueil"><img src="/logo-samnara.png" alt="SamNara" className="logo-img logo-img-lg" /></Link>
      </header>

      <div className="container auth-wrap">
        <motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, ease: EASE }}>
          <div className="eyebrow checkout-eyebrow">Espace membre</div>
          <h1 className="checkout-title">Nouveau mot de passe</h1>

          <div className="checkout-panel">
            {!token ? (
              <p className="auth-error">Lien incomplet — utilise le lien reçu par email.</p>
            ) : done ? (
              <div className="form-success" data-testid="reset-success">
                Mot de passe mis à jour ! Redirection vers la connexion…
              </div>
            ) : (
              <form onSubmit={submit} className="auth-form">
                <div className="activate-head reset-head">
                  <KeyRound size={17} />
                  <b>Choisis ton nouveau mot de passe</b>
                </div>
                {error && <div className="auth-error" data-testid="reset-error">{error}</div>}
                <input
                  type="password"
                  placeholder="Nouveau mot de passe (8 caractères min.)"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  minLength={8}
                  data-testid="reset-password-input"
                />
                <input
                  type="password"
                  placeholder="Confirme le mot de passe"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  required
                  minLength={8}
                  data-testid="reset-confirm-input"
                />
                <button type="submit" className="btn cf-submit" disabled={loading} data-testid="reset-submit-btn">
                  {loading ? "Patiente…" : "Mettre à jour"}
                </button>
              </form>
            )}
          </div>
        </motion.div>
      </div>
    </div>
  );
}
